import { render, staticRenderFns } from "./dynamicFormMixin.vue?vue&type=template&id=00b48491&scoped=true&"
import script from "./dynamicFormMixin.vue?vue&type=script&lang=js&"
export * from "./dynamicFormMixin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b48491",
  null
  
)

export default component.exports